module.exports = __webpack_public_path__ + "img/volume-xmark.de07ca21.svg";